import { render, staticRenderFns } from "./PanelList.vue?vue&type=template&id=819641ec&"
import script from "./PanelList.vue?vue&type=script&lang=js&"
export * from "./PanelList.vue?vue&type=script&lang=js&"
import style0 from "./PanelList.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports